import React, { useEffect, useState } from 'react';

/**
 * SceneTransition Component
 * 
 * Provides smooth fade overlays when transitioning between scenes.
 * Creates a professional, cinematic scroll experience.
 */

export const SceneTransition = ({ currentScene, children }) => {
  const [prevScene, setPrevScene] = useState(currentScene);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (currentScene !== prevScene) {
      setIsTransitioning(true);
      
      // Brief fade effect
      const timer = setTimeout(() => {
        setPrevScene(currentScene);
        setIsTransitioning(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [currentScene, prevScene]);

  return (
    <>
      {children}
      
      {/* Transition overlay */}
      <div
        className={`fixed inset-0 pointer-events-none transition-opacity duration-300 z-40 ${
          isTransitioning ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          background: 'linear-gradient(180deg, rgba(10,22,40,0.3) 0%, rgba(10,22,40,0.1) 100%)',
        }}
        data-testid="scene-transition-overlay"
      />
    </>
  );
};
